import { render, staticRenderFns } from "./SortableColumnHeader.vue?vue&type=template&id=b2fd66da&scoped=true"
import script from "./SortableColumnHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortableColumnHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SortableColumnHeader.vue?vue&type=style&index=0&id=b2fd66da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fd66da",
  null
  
)

export default component.exports